(function () {
  const SWYM_STOREFRONT_TITLE = 'お気に入り';

  function getContainerSelector(root) {
    if (!root || root === document) return 'body';
    if (typeof root === 'string') return root;
    if (root.id) return `#${CSS.escape(root.id)}`;
    return 'body';
  }

  function fixSwymStorefrontTitle(root) {
    (root || document).querySelectorAll('.swym-storefront-layout-title').forEach((title) => {
      if (title.textContent.trim() !== SWYM_STOREFRONT_TITLE) {
        title.textContent = SWYM_STOREFRONT_TITLE;
      }
    });
  }

  function initSwymActionButtons(root) {
    const containerSelector = getContainerSelector(root);

    function run(swat) {
      if (!swat || typeof swat.initializeActionButtons !== 'function') return;
      swat.initializeActionButtons(containerSelector);
      fixSwymStorefrontTitle(root);
    }

    if (window._swat) {
      run(window._swat);
      return;
    }

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(run);
  }

  window.yamagaInitSwymActionButtons = initSwymActionButtons;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initSwymActionButtons();
      fixSwymStorefrontTitle();
    });
  } else {
    initSwymActionButtons();
    fixSwymStorefrontTitle();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initSwymActionButtons(event.target);
    fixSwymStorefrontTitle(event.target);
  });

  window.addEventListener('pageshow', () => {
    initSwymActionButtons();
    fixSwymStorefrontTitle();
  });

  if (!window.yamagaSwymStorefrontTitleObserved) {
    window.yamagaSwymStorefrontTitleObserved = true;
    new MutationObserver(() => fixSwymStorefrontTitle()).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  document.addEventListener(
    'click',
    (event) => {
      if (event.target.closest('.yamaga-card-wishlist-button')) {
        event.stopPropagation();
      }
    }
  );
})();
